import type { LucideIcon, LucideProps } from "lucide-react";
import { cx } from "./cx";

export interface IconProps extends Omit<LucideProps, "ref" | "size" | "strokeWidth" | "color"> {
  /** A Lucide icon component, e.g. `ShoppingCart` from "lucide-react". */
  icon: LucideIcon;
  /** Pixel box. 20 in UI, 24 in navigation. */
  size?: number;
  /** Stroke weight. Kalikaya default 1.75. Do not change per instance. */
  strokeWidth?: number;
  /** Stroke colour. Defaults to currentColor, so icons inherit their text colour. */
  color?: string;
  /** Accessible name. Required when the icon carries meaning alone. */
  label?: string;
}

/** Lucide wrapper. Pins Kalikaya's stroke weight (1.75) and sizing. */
export function Icon({ icon: Glyph, size = 20, strokeWidth = 1.75, color = "currentColor", label, className, ...rest }: IconProps) {
  return (
    <Glyph
      size={size}
      strokeWidth={strokeWidth}
      color={color}
      aria-hidden={label ? undefined : true}
      aria-label={label}
      role={label ? "img" : undefined}
      className={cx("block flex-none", className)}
      {...rest}
    />
  );
}
